import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgxPopupService } from '@components/shared/ngx-popups/ngx-popups/services/ngx-popup.service';
import { TransferBorrowerModalComponent } from '@components/main/borrower/transfer-borrower-modal/transfer-borrower-modal.component';
import { Company } from '@models/company';
import { COMPANY_PAGE_VIEW_MODE } from '@utils/constants';
import { LaunchDarklyService } from '@services/launchdarkly.service';
import { AutoUnsubscribe } from '../../../../decorators/auto-unsubscribe';

export const NO_DOCUMENTS_TOOLTIP =
  'No documents or spreads available to transfer. Upload at least one document to enable this action.';

export const DOCUMENTS_PROCESSING_TOOLTIP =
  'One or more documents are still processing. Please wait for processing to finish before transferring.';

@Component({
  selector: 'app-transfer-borrower-button',
  templateUrl: './transfer-borrower-button.component.html',
  styleUrls: ['./transfer-borrower-button.component.scss'],
  standalone: false,
})
@AutoUnsubscribe('subsArr$')
export class TransferBorrowerButtonComponent implements OnInit, OnChanges, OnDestroy {
  @Input() company!: Company;

  @Input() userEntitlement: string | null | undefined;

  @Input() hasDocuments = false;

  @Input() documentsProcessing = false;

  isVisible = false;

  isEnabled = false;

  tooltip: string | null = null;

  subsArr$: Subscription[] = [];

  private transferFlag = false;

  constructor(
    private popupService: NgxPopupService,
    private _featureFlags: LaunchDarklyService,
  ) {}

  ngOnInit(): void {
    this.subsArr$.push(this._featureFlags.flagChange.subscribe(() => {
      this.readFlag();
      this.recompute();
    }));
    this.readFlag();
    this.recompute();
  }

  ngOnChanges(): void {
    this.recompute();
  }

  ngOnDestroy(): void {
    // Subscriptions cleaned up by @AutoUnsubscribe.
  }

  private readFlag(): void {
    this.transferFlag = !!this._featureFlags.flags['transfer-borrower'];
  }

  private recompute(): void {
    const isTestEntity = !this.company?.externalId;
    const hasFull = this.userEntitlement === COMPANY_PAGE_VIEW_MODE.FULL;
    this.isVisible = this.transferFlag && isTestEntity && hasFull;
    this.isEnabled = this.isVisible && this.hasDocuments && !this.documentsProcessing;
    this.tooltip = this.computeTooltip();
  }

  private computeTooltip(): string | null {
    if (!this.isVisible) {
      return null;
    }
    if (!this.hasDocuments) {
      return NO_DOCUMENTS_TOOLTIP;
    }
    if (this.documentsProcessing) {
      return DOCUMENTS_PROCESSING_TOOLTIP;
    }
    return null;
  }

  onClick(): void {
    this.popupService.open({
      componentType: TransferBorrowerModalComponent,
      cssClass: 'transfer-borrower-modal-popup',
      inputs: { source: this.company },
    });
  }
}
